import {jsonMember, jsonObject} from 'typedjson';

export enum PARAM_TYPE {
    STRING,
    NUMBER,
    BOOL,
    x64
}

@jsonObject
export class SingleParameter {
    @jsonMember
    name: string;
    @jsonMember
    type: string;
    @jsonMember
    value: string;

    public getType(): PARAM_TYPE {
        return PARAM_TYPE[this.type];
    }

    public getValueString(): string {
        switch (this.getType()) {
            case PARAM_TYPE.STRING:
                return this.value;
            case PARAM_TYPE.x64:
                return atob(this.value);
            default:
                return '';
        }
    }

    public getValue(): any {
        switch (this.getType()) {
            case PARAM_TYPE.STRING:
                return this.value;
            case PARAM_TYPE.x64:
                // return atob(this.value);
                return this.b64DecodeUnicode(this.value);
            case PARAM_TYPE.NUMBER:
                return Number(this.value);
            case PARAM_TYPE.BOOL:
                return Boolean(this.value);
            default:
                return '';
        }
    }

    public b64DecodeUnicode(str: string): string {
        if (window
            && 'atob' in window
            && 'decodeURIComponent' in window) {
            return decodeURIComponent(Array.prototype.map.call(atob(str), (c) => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        } else {
            console.warn('b64DecodeUnicode requirements: window.atob and window.decodeURIComponent functions');
            return null;
        }
    }

    public getValueByteByte(): Uint8Array {
        if (this.getType() !== PARAM_TYPE.x64) {
            return new Uint8Array();
        }
        const raw: string = atob(this.value);
        const rawLength: number = raw.length;
        const array = new Uint8Array(new ArrayBuffer(rawLength));
        let i: number;

        for (i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    }

    public get Name(): string {
        return this.name;
    }
}
